<template>
  <v-row no-gutters>
    <v-col cols="12" md="12">
      <v-snackbar :timeout="1000" v-model="isSnackbar" color="success">
        Copy Successful.
      </v-snackbar>
    </v-col>
    <v-col cols="12" md="12">
      <v-row no-gutters>
        <v-infinite-scroll width="100%" :height="heightSize" side="end" @load="load" id="scroll-target"
          v-scroll:#scroll-target="onScroll" class="autoscrollable-wrapper">
          <template v-for="(messageDate, index) in messageDateList" :key="index">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <center>
                  <h5>{{ messageDate.date }}</h5>
                </center>
              </v-col>
              <v-col cols="12" md="12" v-for="(message, index) in messageDate.messageList" :key="index">
                <v-row no-gutters class="pr-2" v-if="message.messageStatus != customerOrPage">
                  <v-col cols="12" md="12" class="pl-2">
                    <v-menu v-model="menu">
                      <template v-slot:activator="{ props }">

                        <span class="borderBlueLeft pa-2" v-bind="props" @click.left.prevent="menu = false">
                          <span v-if="message.sendPhoto == undefined"
                            @click.right.prevent="menuDialog(message, 'copy')">

                            <span v-if="message.replyId > 0" class="borderReply pa-2" @click="clickReply(message)">
                              <span>
                                <h6>{{ message.replyProfileName }}</h6>
                              </span>
                              <span class="text-caption">
                                <span v-if="message.replySendPhoto == undefined">{{ message.replyMessage }}</span>
                                <span v-else>
                                  <v-img v-if="message.replyFileType == '.png'" width="100" lazy-src="/info/logo.png"
                                    :src="srcMethodReplyPhoto(message.replyId, message.replySendPhoto)"></v-img>
                                  <span v-else>
                                    <v-icon class="pl-2" color="black">mdi-file-download</v-icon>
                                    {{ message.replySendPhoto }}{{ message.replyFileType }}
                                  </span>
                                </span>
                              </span>
                            </span>

                            <span>
                              <h5>{{ message.sendMessage }}</h5>
                            </span>
                            <span>
                              <v-row no-gutters>
                                <v-col class="text-caption text-right">
                                  {{ message.time }}
                                </v-col>
                              </v-row>
                            </span>
                          </span>

                          <span v-else @click.right.prevent="menuDialog(message, 'reply')">
                            <v-img v-if="message.fileType == '.png'" :width="imgWidth" lazy-src="/info/logo.png"
                              :src="srcMethodSendPhoto(message)" @click="clickPhotoDialog(message)">
                              <template v-slot:placeholder>
                                <div class="d-flex align-center justify-center fill-height">
                                  <v-progress-circular color="primary" indeterminate></v-progress-circular>
                                </div>
                              </template>
                            </v-img>
                            <span v-else @click="clickDownload(message)">
                              <v-icon class="pl-2" color="black">mdi-file-download</v-icon>
                              {{ message.sendPhoto }}{{ message.fileType }}
                            </span>
                            <span>
                              <v-row no-gutters>
                                <v-col class="text-caption text-right">
                                  {{ message.time }}
                                </v-col>
                              </v-row>
                            </span>
                          </span>

                        </span>
                      </template>

                      <v-list density="compact" v-if="
                        menu && menuSelected.messageId == message.messageId
                      ">
                        <v-list-item v-for="(item, i) in rightMenuList" :key="i"
                          @click="clickEditDelete(item, messageDate, index)">
                          <template v-slot:prepend>
                            <v-icon :icon="item.icon" size="x-small"></v-icon>
                          </template>
                          <v-list-item-title density="compact">{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row no-gutters class="pr-2" v-else>
                  <v-col cols="12" md="12">
                    <v-menu v-model="menu">
                      <template v-slot:activator="{ props }">
                        <span class="borderBlueRight pa-2" v-bind="props" @click.left.prevent="menu = false">

                          <span v-if="message.sendPhoto == undefined" @click.right.prevent="menuDialog(message, 'all')">

                            <span v-if="message.replyId > 0" class="borderReply pa-2" @click="clickReply(message)">
                              <span>
                                <h6>{{ message.replyProfileName }}</h6>
                              </span>
                              <span class="text-caption">
                                <span v-if="message.replySendPhoto == undefined">{{ message.replyMessage }}</span>
                                <span v-else>
                                  <v-img v-if="message.replyFileType == '.png'" width="100" lazy-src="/info/logo.png"
                                    :src="srcMethodReplyPhoto(message.replyId, message.replySendPhoto)"></v-img>
                                  <span v-else>
                                    <v-icon class="pl-2" color="black">mdi-file-download</v-icon>
                                    {{ message.replySendPhoto }}{{ message.replyFileType }}
                                  </span>
                                </span>
                              </span>
                            </span>

                            <span>
                              <h5>{{ message.sendMessage }}</h5>
                            </span>
                            <span>
                              <v-row no-gutters>
                                <v-col class="text-caption text-right">
                                  {{ message.time }}
                                  <v-icon size="small" class="pl-2" v-if="message.look >= 0">mdi-check-all</v-icon>
                                  <v-icon size="small" class="pl-2" color="blue" v-else>mdi-check-all</v-icon>
                                </v-col>
                              </v-row>
                            </span>
                          </span>


                          <span v-else @click.right.prevent="menuDialog(message, 'delete')">
                            <v-img v-if="message.fileType == '.png'" :width="imgWidth" lazy-src="/info/logo.png"
                              :src="srcMethodSendPhoto(message)" @click="clickPhotoDialog(message)">
                              <template v-slot:placeholder>
                                <div class="d-flex align-center justify-center fill-height">
                                  <v-progress-circular color="primary" indeterminate></v-progress-circular>
                                </div>
                              </template>
                            </v-img>
                            <span v-else @click="clickDownload(message)">
                              <v-icon class="pl-2" color="black">mdi-file-download</v-icon>
                              {{ message.sendPhoto }}{{ message.fileType }}
                            </span>
                            <span>
                              <v-row no-gutters>
                                <v-col class="text-caption text-right">
                                  {{ message.time }}
                                  <v-icon size="small" class="pl-2" v-if="message.look >= 0">mdi-check-all</v-icon>
                                  <v-icon size="small" class="pl-2" color="blue" v-else>mdi-check-all</v-icon>
                                </v-col>
                              </v-row>
                            </span>
                          </span>

                        </span>
                      </template>

                      <v-list density="compact" v-if="
                        menu && menuSelected.messageId == message.messageId
                      ">
                        <v-list-item v-for="(item, i) in rightMenuList" :key="i"
                          @click="clickEditDelete(item, messageDate, index)">
                          <template v-slot:prepend>
                            <v-icon :icon="item.icon" size="x-small"></v-icon>
                          </template>
                          <v-list-item-title density="compact">{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-infinite-scroll>
      </v-row>
    </v-col>

    <v-col cols="12" md="6" offset-md="0" class="pt-2 app-fab--absolute pl-2">
      <v-row no-gutters class="black pa-2">
        <v-col cols="12" md="12" v-if="showDownArrow && showDownArrowTwo">
          <v-row no-gutters>
            <v-col cols="11" md="11"> </v-col>
            <v-col cols="1" md="1" class="mb-2">
              <v-badge :content="badgeCount" color="primary" v-if="badgeCount > 0">
                <v-icon color="black" size="x-large" @click="clickDownArrow()">mdi-arrow-down-circle</v-icon>
              </v-badge>
              <v-icon v-else color="black" size="x-large" @click="clickDownArrow()">mdi-arrow-down-circle</v-icon>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="12" class="bg-grey pl-2 text-caption" v-if="saveOrupdate == 'update'">
          <v-row no-gutters>
            <v-col cols="11" md="11">
              <span>Edit message</span>
            </v-col>
            <v-col cols="1" md="1">
              <v-icon @click="clickEditClear()">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="bg-grey pl-2 text-caption"
          v-else-if="message.replyDto != undefined && message.replyDto.messageId > 0">
          <v-row no-gutters v-if="message.replyDto.sendPhoto == undefined">
            <v-col cols="11" md="11">
              <span>{{ message.replyDto.sendMessage }}</span>
            </v-col>
            <v-col cols="1" md="1">
              <v-icon @click="clickEditClear()">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row no-gutters v-else class="pa-1">
            <v-col cols="2" md="2">
              <span>
                <v-img width="50" height="50" lazy-src="/info/logo.png"
                  :src="srcMethodSendPhoto(message.replyDto)"></v-img>
              </span>
            </v-col>
            <v-col cols="9" md="9" class="mt-4">
              Photo Message
            </v-col>
            <v-col cols="1" md="1" class="mt-4">
              <v-icon @click="clickEditClear()">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" md="1">
          <label for="file-input">
            <img src="../info/addplus.png" width="30" height="30" class="mt-1" />
          </label>
          <input :disabled="!showDownArrowTwo && scrollSize > 0" id="file-input" type="file" ref="file"
            style="display: none" @change="readmultifiles" multiple />
        </v-col>
        <v-col cols="10" md="10">
          <v-textarea :disabled="!showDownArrowTwo && scrollSize > 0" rows="1" label="Message ..."
            v-model="message.sendMessage" variant="outlined" density="compact" @keyup.enter="saveMessage()" />
        </v-col>
        <v-col cols="1" md="1">
          <center>
            <v-btn class="mt-1" color="primary" icon density="compact" @click="saveMessage()"
              :disabled="!showDownArrowTwo && scrollSize > 0">
              <v-icon color="white" size="x-small">mdi-send</v-icon>
            </v-btn>
          </center>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="12">
      <v-bottom-sheet v-model="dialogMessagePhoto" fullscreen scrollable>
        <v-sheet class="information-window-v-sheet">
          <DialogMessagePhoto @closeDialog="dialogMessagePhoto = false" :refreshMessage="refreshMessage"
            :messagePhoto="messagePhoto" />
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
  </v-row>
</template>
<script>
import pgService from "../service/PageService";
import axios from "../config";
import messageService from "../service/MessageService";
import DialogMessagePhoto from "@/components/DialogMessagePhoto.vue";
export default {
  data: () => ({
    page: {},
    message: { pageDto: {} },
    loginUser: {},
    messageDate: { finalMessageId: 0 },
    messageDateList: [],
    offsetTop: 0,
    scrollSize: 0,
    showDownArrow: false,
    showDownArrowTwo: false,
    tempMessageDateList: [],
    tempIndex: 0,
    badgeCount: 0,
    menu: false,
    menuSelected: {},
    rightMenuList: [],
    saveOrupdate: "save",
    dialogMessagePhoto: false,
    refreshMessage: 0,
    messagePhoto: {},
    heightSize: "87vh",
    imgWidth: "40vh",
    customerOrPage: "",
    isSnackbar: false,
  }),
  props: { pageId: Number, dialogDisconnect: Number },
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.customerOrPage = this.$store.state.customerOrPage;
    //this.pagePhoto = this.storePage.photo;
    if (this.showComputer) {
      this.heightSize = "87vh";
      this.imgWidth = "40vh";
    } else {
      this.heightSize = "80vh";
      this.imgWidth = "20vh";
    }
    this.disconnect();
    this.connection();
  },
  methods: {
    clickDownload: function (message) {
      let photo = message.sendPhoto + message.messageId + message.fileType;
      const link = document.createElement("a");
      link.href =
        `${axios.defaults.baseURL}/photo/` + photo;
      link.setAttribute("download", photo);
      document.body.appendChild(link);
      link.click();
    },
    clickReply: function (item) {
      messageService
        .getMessage(
          this.pageId,
          0,
          this.loginUser.userId,
          this.customerOrPage,
          item.replyId
        )
        .then((response) => {
          this.messageDateList.splice(0, this.messageDateList.length);
          this.messageDate = Object.assign({}, response);
          this.messageDateList.push(...this.messageDate.messageDateList); //unshift
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    clickPhotoDialog: function (item) {
      this.dialogMessagePhoto = true;
      this.messagePhoto = Object.assign({}, item);
      this.messagePhoto.customerId = this.loginUser.userId;
      this.messagePhoto.pageId = this.pageId;
    },
    readmultifiles: function (e) {
      const files = e.target.files;
      Object.keys(files).forEach((i) => {
        const file = files[i];
        var formData = new FormData();
        formData.append("file", file);
        let fileType = file.name.split('.')[1];
        if ("jpg" == fileType) {
          fileType = "png";
        }
        messageService
          .saveMessagePhoto(
            formData,
            this.pageId,
            this.loginUser.userId,
            this.customerOrPage,
            0, fileType
          )
          .then((response) => {
            //this.clickMessageListMethod();
            if (this.showDownArrow) {
              this.clickDownArrow();
            }
          })
          .catch((error) => {
            this.$swal("မအောင်မြင်ပါ", error.response.data.message, "error");
          });
      });
    },
    clickEditClear: function () {
      this.saveOrupdate = "save";
      this.message = { pageDto: {}, replyDto: {} };
    },
    clickEditDelete: function (item, messageDate, position) {
      this.menu = false;
      if ("Delete" == item.title) {
        messageService
          .deleteMessage(this.menuSelected, this.pageId, this.loginUser.userId)
          .then((response) => {
            //messageDate.messageList.splice(position,1);
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      } else if ("Copy" == item.title) {
        this.isSnackbar = true;
        navigator.clipboard.writeText(this.menuSelected.sendMessage);
      } else if ("Reply" == item.title) {
        this.message.replyDto = Object.assign({}, this.menuSelected);
      } else {
        this.saveOrupdate = "update";
        this.message = Object.assign({}, this.menuSelected);
      }
    },
    menuDialog: function (item, type) {
      this.rightMenuList.splice(0);
      this.rightMenuList.push({
        title: "Reply",
        icon: "mdi-reply",
      });
      if ("all" == type) {
        this.rightMenuList.push({
          title: "Copy",
          icon: "mdi-content-copy",
        });
        this.rightMenuList.push({
          title: "Edit",
          icon: "mdi-pencil",
        });
        this.rightMenuList.push({
          title: "Delete",
          icon: "mdi-delete",
        });
      } else if ("copy" == type) {
        this.rightMenuList.push({
          title: "Copy",
          icon: "mdi-content-copy",
        });
      } else if ("delete" == type) {
        this.rightMenuList.push({
          title: "Delete",
          icon: "mdi-delete",
        });
      }
      this.menu = true;
      this.menuSelected = Object.assign({}, item);
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    connection() {
      this.connected ? this.disconnect() : this.connect();
    },
    connect() {
      let socket = new SockJS("/chat");
      this.stompClient = Stomp.over(socket);
      this.stompClient.connect(
        {},
        (frame) => {
          this.connected = true;
          this.stompClient.subscribe(
            "/mbt/page/" + this.pageId + "/" + this.loginUser.userId,
            (response) => {
              let userObj = JSON.parse(response.body);

              if (userObj.saveOreditOrdelete == "look") {
                for (var i = 0; i < this.messageDateList.length; i++) {
                  let messageDate = this.messageDateList[i];
                  for (var j = 0; j < messageDate.messageList.length; j++) {
                    let message = messageDate.messageList[j];
                    message.look = -1;
                  }
                }
              } else if (userObj.saveOreditOrdelete == "save") {
                if (
                  this.loginUser.userId != userObj.userAccountDto.userAccountId
                ) {
                  pgService
                    .updateMessageLook(this.pageId, this.customerOrPage, this.loginUser.userId)
                    .then((response) => { })
                    .catch((error) => {
                      //this.$swal("Fail!", error.response.data.message, "error");
                    });
                }

                if (this.messageDateList.length == 0) {
                  this.clickMessageListMethod();
                } else {
                  this.messageDateList[0].messageList.push(userObj); //push
                  if (
                    this.loginUser.userId ==
                    userObj.userAccountDto.userAccountId ||
                    !this.showDownArrow
                  ) {
                    // if (this.scrollSize > 0) {
                    //   this.clickDownArrow();
                    // }
                  } else {
                    this.badgeCount = Number(this.badgeCount) + 1;
                  }
                }
              } else if (userObj.saveOreditOrdelete == "delete") {
                for (var i = 0; i < this.messageDateList.length; i++) {
                  let messageDate = this.messageDateList[i];
                  messageDate.messageList = messageDate.messageList.filter(
                    (e) => e.messageId !== userObj.messageId
                  );
                }
              } else if (userObj.saveOreditOrdelete == "update") {
                for (var i = 0; i < this.messageDateList.length; i++) {
                  let messageDate = this.messageDateList[i];
                  for (var j = 0; j < messageDate.messageList.length; j++) {
                    let message = messageDate.messageList[j];
                    if (message.messageId == userObj.messageId) {
                      messageDate.messageList[j] = userObj;
                      break;
                    }
                  }
                }
              }
            }
          );
        },
        (error) => {
          this.connected = false;
        }
      );
    },
    clickDownArrow: function () {
      this.tempMessageDateList.push(...this.messageDateList);
      this.messageDateList.splice(0);
      this.tempIndex = 1;
    },
    onScroll(e) {
      this.offsetTop = -e.target.scrollTop;
      this.scrollSize = e.target.scrollHeight - 700; //620
      if (this.offsetTop > 50) {
        this.showDownArrow = true;
      } else {
        this.badgeCount = 0;
        this.showDownArrow = false;
      }
      if (this.offsetTop < this.scrollSize) {
        this.showDownArrowTwo = true;
      } else {
        this.showDownArrowTwo = false;
      }
      this.menu = false;
    },
    load({ done }) {
      if (this.tempIndex == 0) {
        setTimeout(() => {
          this.messageListMethod(done);
          //done('ok')
        }, 500);
      } else {
        done("ok");
        this.messageDateList.push(...this.tempMessageDateList);
        this.tempMessageDateList.splice(0);
        this.tempIndex = 0;
        this.badgeCount = 0;
      }
    },
    saveMessage: function () {
      if (this.saveOrupdate == "save") {
        if (
          this.message.sendMessage != "" &&
          this.message.sendMessage != undefined
        ) {
          this.message.pageDto.pageId = this.pageId;
          this.message.customerOrPage = this.customerOrPage;
          messageService
            .addMessage(this.message)
            .then((response) => {
              this.clickEditClear();
              if (this.showDownArrow) {
                this.clickDownArrow();
              }
            })
            .catch((error) => {
              this.$swal("Fail!", error.response.data.message, "error");
            });
        }
      } else {
        if (
          this.message.sendMessage != "" &&
          this.message.sendMessage != undefined
        ) {
          this.message.pageDto.pageId = this.pageId;
          this.message.customerOrPage = this.customerOrPage;
          messageService
            .updateMessage(this.message)
            .then((response) => {
              this.clickEditClear();
            })
            .catch((error) => {
              this.$swal("Fail!", error.response.data.message, "error");
            });
        }
      }
    },
    messageListMethod: function (done) {
      if (this.messageDate.finalMessageId >= 0) {
        messageService
          .getMessage(
            this.pageId,
            this.messageDate.finalMessageId,
            this.loginUser.userId,
            this.customerOrPage
          )
          .then((response) => {
            this.messageDate = Object.assign({}, response);
            this.messageDateList.push(...this.messageDate.messageDateList); //unshift

            if (this.messageDate.messageDateList.length > 0) {
              done("ok");
            } else {
              this.messageDate.finalMessageId = -1;
              done("error");
            }
          })
          .catch((error) => {
            this.$swal("Fail!", error.response.data.message, "error");
          });
      } else {
        done("error");
      }
    },
    clickMessageListMethod: function () {
      messageService
        .getMessage(this.pageId, 0, this.loginUser.userId, this.customerOrPage)
        .then((response) => {
          this.messageDateList.splice(0, this.messageDateList.length);
          this.messageDate = Object.assign({}, response);
          this.messageDateList.push(...this.messageDate.messageDateList); //unshift
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
    },
    // pageMethod: function () {
    //   pgService
    //     .getPageById(this.pageId)
    //     .then((response) => {
    //       this.page = Object.assign({}, response);
    //     })
    //     .catch((error) => {
    //       this.$swal("Fail!", error.response.data.message, "error");
    //     });
    // },
    srcMethod: function (pictureCode) {
      return `${axios.defaults.baseURL}/pagephoto/${pictureCode}.png`;
    },
    srcMethodProfile: function (pictureCode) {
      if (pictureCode == undefined) {
        return `/info/logo.png`;
      } else {
        return `${axios.defaults.baseURL}/userphoto/${pictureCode}.png`;
      }
    },
    srcMethodSendPhoto: function (message) {
      let photo = message.sendPhoto + message.messageId;
      return `${axios.defaults.baseURL}/photo/${photo}.png`;
    },
    srcMethodReplyPhoto: function (replyId, sendPhoto) {
      let photo = sendPhoto + replyId;
      return `${axios.defaults.baseURL}/photo/${photo}.png`;
    },
  },
  watch: {
    pageId() {
      this.disconnect();
      this.clickMessageListMethod();
      this.connection();
      //this.pagePhoto = this.$store.state.page.photo;
    },
    dialogDisconnect() {
      this.disconnect();
    },
  },
  components: { DialogMessagePhoto },
  computed: {
    showComputer() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
  },
};
</script>
<style scoped>
.app-fab--absolute {
  position: fixed;
  bottom: -1.5rem;
}

@media (min-width: 1024px) {
  .app-fab--absolute {
    bottom: -1.5rem;
  }
}

/* .borderBlue {
  background-color: #def3ff;
} */
.borderBlueLeft {
  background: #efefef;
  margin-top: 5px;
  padding-left: 5px;
  display: inline;
  float: left;
  padding-right: 9px;
  border-start-end-radius: 10px;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
}

.borderBlueRight {
  background: #def3ff;
  margin-top: 5px;
  padding-left: 5px;
  display: inline;
  float: right;
  padding-right: 9px;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  border-start-start-radius: 10px;
}

.autoscrollable-wrapper {
  overflow: auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column-reverse;
}

.information-window-v-sheet {
  height: 100vh !important;
  overflow-x: scroll;
}

.borderReply {
  background: #f4f2f2;
  display: inline;
  float: right;
}
</style>